/**
 * unknown型のエラーからメッセージを安全に抽出する
 * @param error 抽出対象のエラー値
 * @param fallback エラーメッセージが取得できない場合のフォールバック文字列
 * @returns エラーメッセージ文字列
 */
export function extractErrorMessage(
  error: unknown,
  fallback = '予期しないエラーが発生しました'
): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return fallback;
}
